import Alert from '@jbhi-fi/lanyard-ui/components/Alert';
import React from 'react';
import { CustomerCollectInformation } from '../CustomerCollectInformation';
import { DeliveryInformation } from '../DeliveryInformation';
import { styles } from './ExperienceInformation.css';
import {
  AlertProps,
  BaseContentSection,
  CarrierInformation,
  ShipmentStatus,
  StoreInformationType,
} from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import { MarkdownBlock } from '../../MarkdownBlock';
import { useNavigate } from '../../PlatformFunctionality';

export type ExperienceInformationProps = {
  status: ShipmentStatus;
  footer?: BaseContentSection;
  alert?: BaseContentSection & AlertProps;
  importantText?: BaseContentSection;
  confirmationText?: BaseContentSection;
  carrier?: CarrierInformation;
  trackingUrl?: string;
  consignmentNumber?: string;
  store?: StoreInformationType;
};

export const ExperienceInformation = ({
  status,
  footer,
  alert,
  importantText,
  confirmationText: confirmationText,
  carrier,
  trackingUrl,
  consignmentNumber,
  store,
}: ExperienceInformationProps) => {
  const navigate = useNavigate();
  const handleStoreDirectionsSearch = () => {
    if (!store?.directionsLink) return;
    navigate(store?.directionsLink);
  };

  const getFulfilmentComponent = () => {
    if (carrier)
      return (
        <DeliveryInformation
          carrier={carrier}
          trackingUrl={trackingUrl}
          consignmentNumber={consignmentNumber}
          footerContent={footer}
          importantText={importantText}
          confirmationText={confirmationText}
        />
      );

    if (store)
      return (
        <CustomerCollectInformation
          store={store}
          onStoreDirectionSearch={handleStoreDirectionsSearch}
          status={status}
          importantText={importantText}
        />
      );
    return null;
  };

  const getHeader = () => {
    if (carrier) {
      return 'Delivered by';
    }
    if (store) {
      switch (status) {
        case 'Collected':
          return 'Collected from';
        case 'AwaitingCollection':
          return 'Collect from';
        default:
          return 'Collecting from';
      }
    }
  };

  return (
    <div className={styles.container}>
      <div role="heading" aria-level={3} className={styles.header}>
        {getHeader()}
      </div>
      {getFulfilmentComponent()}
      {alert ? (
        <Alert
          classes={styles.instructionsAlert}
          showIcon
          {...alert}
          content={<MarkdownBlock shouldLinkOpenInNewTab>{alert.content || ''}</MarkdownBlock>}
        />
      ) : null}
    </div>
  );
};
